import { AxiosError } from 'axios';
import { api } from '@shared/api';

export class PasswordResetError extends Error {
  constructor(public code: 'INVALID_EMAIL' | 'WEAK_PASSWORD' | 'EXPIRED_TOKEN' | 'NETWORK') {
    super(code);
    this.name = 'PasswordResetError';
  }
}

export async function requestReset(payload: { email: string }): Promise<{ ok: true; sentTo: string }> {
  try {
    await api.post('/auth/reset-password', payload);
    return { ok: true, sentTo: payload.email };
  } catch (err) {
    throw mapError(err);
  }
}

export async function submitNewPassword(payload: { token: string; password: string }): Promise<{ ok: true }> {
  try {
    await api.post('/auth/reset-password-confirmation', payload);
    return { ok: true };
  } catch (err) {
    throw mapError(err);
  }
}

export interface ResetTokenStatus {
  valid: boolean;
  email: string | null;
  expiresInSeconds: number;
}

/** Upfront-валидация ссылки сброса (read-only, токен НЕ потребляется).
 *  Ответ всегда 200; решает экран по полю `valid`. */
export async function verifyResetToken(token: string): Promise<ResetTokenStatus> {
  const { data } = await api.post('/auth/reset-password/verify', { token });
  return {
    valid: Boolean(data?.valid),
    email: (data?.email as string | null) ?? null,
    expiresInSeconds: Number(data?.expires_in_seconds ?? 0),
  };
}

function mapError(err: unknown): PasswordResetError {
  if (err instanceof AxiosError) {
    const status = err.response?.status;
    // Использованную, истёкшую и погашенную сменой пароля ссылку сервер отдаёт как 400 TOKEN_EXPIRED.
    const code = (err.response?.data as { error?: { code?: string } } | undefined)?.error?.code;
    if ((status === 400 && code === 'TOKEN_EXPIRED') || status === 401 || status === 404) {
      return new PasswordResetError('EXPIRED_TOKEN');
    }
    if (status === 422) return new PasswordResetError('INVALID_EMAIL');
    if (!err.response) return new PasswordResetError('NETWORK');
  }
  return new PasswordResetError('WEAK_PASSWORD');
}
